import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Records";
import getToken from "app/api/getToken";
import { IRecordRequest, IRecordResponse } from "app/api/types";

export const GET_RECORDS_REQUEST = "GET_RECORDS_REQUEST";
export const GET_RECORDS_SUCCESS = "GET_RECORDS_SUCCESS";
export const GET_RECORDS_FAIL = "GET_RECORDS_FAIL";

export const getRecords = (date: IRecordRequest["date"]) => (
  dispatch: any
): any => {
  dispatch({ type: GET_RECORDS_REQUEST });

  const token = getToken();

  return api
    .getRecords(token, date)
    .then((response: AxiosResponse) => {
      const recordList: IRecordResponse[] = get(response, "data", {});
      dispatch({ type: GET_RECORDS_SUCCESS, payload: recordList });

      return recordList;
    })
    .catch(err => {
      dispatch({
        type: GET_RECORDS_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
